import { Section, Eyebrow } from "./Primitives";
import { MaskedLines, FadeUp } from "./Reveal";
import { ABOUT, MISSION } from "../../data/content";

export function About() {
  return (
    <Section id="about" className="py-24 md:py-36">
      <Eyebrow>{ABOUT.eyebrow}</Eyebrow>
      <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-20">
        <h2 className="font-display text-[2.4rem] font-light leading-[1.06] tracking-[-0.015em] text-content sm:text-5xl md:text-6xl">
          <MaskedLines
            lines={[
              "RunLoop is an",
              [
                { t: "efficiency ", em: false },
                { t: "partner.", em: true },
              ],
            ]}
            stagger={0.12}
          />
        </h2>
        <FadeUp delay={0.15} className="flex flex-col justify-end gap-5">
          <p className="text-lg leading-relaxed text-content md:text-xl">
            Most businesses run on more manual work than they should. We help you run on less.
          </p>
          <p className="text-base leading-relaxed text-mutedc md:text-lg">{ABOUT.body}</p>
        </FadeUp>
      </div>
    </Section>
  );
}

export function Mission() {
  return (
    <Section id="mission" className="py-24 md:py-40">
      <Eyebrow className="mb-10">{MISSION.eyebrow}</Eyebrow>
      <h2 className="max-w-6xl font-display text-3xl font-light leading-[1.14] tracking-tight text-content sm:text-4xl md:text-5xl">
        {MISSION.headParts.map((p, i) =>
          p.em ? (
            <span key={i} className="emph">
              {p.t}
            </span>
          ) : (
            <span key={i}>{p.t}</span>
          )
        )}
      </h2>
    </Section>
  );
}
